import React, { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = 'https://iudzzeqvihyxbzdvooeq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1ZHp6ZXF2aWh5eGJ6ZHZvb2VxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5Nzc4MDcsImV4cCI6MjA3MjU1MzgwN30.KcSOr8Oa0fnSaeWWBNXZy0osMOdL2od_tJ3vOV_-c44';
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Lire l'erreur depuis l'URL si elle existe
    const params = new URLSearchParams(window.location.search);
    const errorDescription = params.get('error_description');
    if (errorDescription) {
      setError(decodeURIComponent(errorDescription));
    }
  }, []);

  const signInWithMicrosoft = async () => {
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "azure",
      options: {
        scopes: "openid profile email offline_access",
      },
    });
    if (error) setError(error.message);
    setLoading(false);
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-100 via-indigo-100 to-cyan-100">
      {/* Glow/Gradient décoratif */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute left-[-15vw] top-[-5vh] w-[50vw] h-[40vh] bg-gradient-to-bl from-[#6366f1] via-[#f472b6] to-[#06b6d4] rounded-full blur-[80px] opacity-40"></div>
        <div className="absolute right-[-10vw] bottom-[-5vh] w-[40vw] h-[35vh] bg-gradient-to-tl from-[#06b6d4] via-[#93c5fd] to-[#6366f1] rounded-full blur-[90px] opacity-30"></div>
        <div className="absolute left-1/2 top-1/2 w-[60vw] h-[20vh] bg-gradient-to-r from-[#fff] via-[#c7d2fe] to-[#f472b6] rounded-full blur-[120px] opacity-35 transform -translate-x-1/2 -translate-y-1/2"></div>
      </div>

      {/* Centre glassmorphism */}
      <div className="z-10 w-full max-w-md px-8 py-12 bg-white/40 backdrop-blur-lg rounded-3xl shadow-2xl flex flex-col items-center shadow-indigo-100">
        <h1 className="text-4xl md:text-5xl font-extrabold text-indigo-900 mb-2 text-center drop-shadow-lg">JuniAtmo</h1>

        <button
          onClick={signInWithMicrosoft}
          disabled={loading}
          className="flex items-center space-x-3 bg-white hover:bg-indigo-50 text-indigo-700 font-bold rounded-xl px-8 py-3 shadow-xl transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-indigo-300"
          aria-label="Se connecter avec Microsoft"
        >
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="1" y="1" width="10" height="10" fill="#F35325" />
            <rect x="13" y="1" width="10" height="10" fill="#81BC06" />
            <rect x="1" y="13" width="10" height="10" fill="#05A6F0" />
            <rect x="13" y="13" width="10" height="10" fill="#FABB05" />
          </svg>
          <span>{loading ? "Connexion..." : "Se connecter avec Microsoft"}</span>
        </button>

        {error && (
          <p className="text-red-400 font-semibold mt-6" role="alert" aria-live="assertive">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
